import { makeStyles } from "@material-ui/core/styles";

export const wantToAchiveStyles = makeStyles((theme) => ({
  answer: {
    height: "350px",
    border: "1px solid #A7BBD4",
    borderRadius: "10px",
    "& .MuiButton-label": {
      display: "block",
    },
    "& img": {
      width: "100%",
    },
    "& .answerDescription": {
      color: "black",
      fontFamily: "Lato",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: theme.typography.pxToRem(16),
    },
  },
}));
